import { isEqual } from "lodash";
import dayjs from "dayjs";
import { SmlJsonQuery, SmlJsonQueryFilter, SmlJsonQueryOrder } from "@src/types/intelligence-search";
import { config } from "@src/config";

export type QuestionForm = {
    json_query: SmlJsonQuery;
    time_range: string[];
    question_id: number;
    question_name: string;
    json_query_builder_config: JsonQueryBuilderConfig;
    query_dependencies?: Record<string, string[]>;
    query_dependencies_type?: string;
};

export interface JsonQueryBuilderConfig {
    limit: number;
    orders: SmlJsonQueryOrder[];
    selected_assets_or_filters: SmlJsonQueryFilter[];
}

type RootConfig = {
    product_code: string;
    platform: string[];
    questions: QuestionForm[];
};
export function isFormMultipleConfigChange(before: RootConfig, after: RootConfig): boolean {
    // Create normalized versions with formatted time ranges
    const normalizedBefore = normalizeConfigForComparison(before);
    const normalizedAfter = normalizeConfigForComparison(after);

    return !isEqual(normalizedBefore, normalizedAfter);
}

function normalizeConfigForComparison(config: RootConfig): RootConfig {
    return {
        ...config,
        questions: config.questions?.map((question) => {
            const { json_query, ...questionWithoutJsonQuery } = question;
            return {
                ...questionWithoutJsonQuery,
                time_range: normalizeTimeRange(question.time_range),
            } as QuestionForm;
        }),
    };
}

function normalizeTimeRange(timeRange: string[]): string[] {
    return timeRange?.map((date) => dayjs(date).format(config.DATE_FORMAT));
}
